<template>
  <div>
      <Header />
      <Menu />

      <div class="container">  
        <div class="block">
          <div class="image">
            <img src="/images/Trauma.jpg" alt="">
          </div>
          <div class="text">
            <div class="header">
              What I do
            </div>
            <div class="content">
              My name is Justin Thouless, I am a Freelance Graphic Designer operating out of Ontario, Canada. Most of my work consists of Star Wars fan art, but sometimes you can find me drawing unrelated pieces. I tend to focus my efforts into pieces that motivate me, Star Wars has always been a strong source of inspiration in my life and I hope my work portrays that. As an inspiring Graphic Designer, I am always looking for new and interesting challenges to further my skills, if you would be interested in challenging me, feel free to <a href="mailto:contact@thoulessart.com" class="gray">contact me</a>.
            </div>
          </div>
        </div>
      </div>

      <Footer />
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
.text, .content, .gray {
  color: rgba(255, 255, 255, 0.87) !important;
}
</style>